import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { gettingDetail } from '../../Redux/Actions/DashOptions'
import Loader from '../../Common/Loader'

const ViewMemberPage = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()

    const getMemerDetail = useSelector((state) => state?.DashOptionsSlice?.detailOfMember)
    const getMemberDetailLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading)
    useEffect(() => {
        if (id) {
            dispatch(gettingDetail(id))
        }
    }, [id])
    return (
        <div className="flex justify-center items-center py-12">
            {getMemberDetailLoading && <Loader />}
            <div className="bg-white shadow-2xl border border-gray-100 rounded-xl px-10 py-8 w-full max-w-5xl">
                <h2 className="text-3xl font-bold text-center text-indigo-700 mb-6">Member Details</h2>

                <div className="grid grid-cols-2 gap-4 text-sm text-gray-800">
                    <div>
                        <span className="block font-medium text-gray-500">Full Name</span>
                        <p className='font-semibold text-gray-900'>{getMemerDetail?.name || '-'}</p>
                    </div>
                    <div>
                        <span className="block font-medium text-gray-500">Date of Birth</span>
                        <p className='font-semibold text-gray-900'>{getMemerDetail?.dob || '-'}</p>
                    </div>
                    <div>
                        <span className="block font-medium text-gray-500">SSN</span>
                        <p className='font-semibold text-gray-900'>{getMemerDetail?.ssn || '-'}</p>
                    </div>
                    <div>
                        <span className="block font-medium text-gray-500">Provider</span>
                        <p className='font-semibold text-gray-900'>{getMemerDetail?.provider?.name || '-'}</p>
                    </div>
                    <div>
                        <span className="block font-medium text-gray-500">Type</span>
                        <p className='font-semibold text-gray-900'>{getMemerDetail?.type?.name || '-'}</p>
                    </div>
                    <div>
                        <span className="block font-medium text-gray-500">Member ID</span>
                        <p className='font-semibold text-gray-900'>{getMemerDetail?.member_id || '-'}</p>
                    </div>
                    <div>
                        <span className="block font-medium text-gray-500">Auth Start Date</span>
                        <p className='font-semibold text-gray-900'>{getMemerDetail?.start_date || '-'}</p>
                    </div>
                    <div>
                        <span className="block font-medium text-gray-500">Last Covered Date</span>
                        <p className='font-semibold text-gray-900'>{getMemerDetail?.last_cover_date || '-'}</p>
                    </div>
                    <div>
                        <span className="block font-medium text-gray-500">Status</span>
                        <p className='font-semibold text-gray-900'>{getMemerDetail?.status || '-'}</p>
                    </div>
                </div>

                <div className="flex justify-end pt-6">
                    <button
                        onClick={() => navigate('/dashboard/memberlisting')}
                        className="px-5 py-2 text-white bg-indigo-600 hover:bg-indigo-700 rounded-md transition"
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ViewMemberPage
